module.exports = __webpack_public_path__ + "assets/img/swipe.9cc332d2.png";